<router-outlet [routerOutletData]="{ isAdmin: outletData().isAdmin }"></router-outlet>
